<template>
  <ElevatedButton class="">
    <slot>
      {{ $t('Save') }}
    </slot>
  </ElevatedButton>
</template>

<script setup lang="ts">
import ElevatedButton from './ElevatedButton.vue';

</script>
